import React, { Component } from 'react';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import { Table, Form, FormGroup, Label, Input } from 'reactstrap';
import { GoCheck } from 'react-icons/go';
import { connect } from 'react-redux';

class Acadeum extends Component {
    static displayName = Acadeum.name;

    constructor(props) {
        super(props);
        
        this.state = {
            loading: false,
            loadingTable: true,
            selectVal: "",
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            globalLevel: "",
            tableData: [],
            selectdata: [],
            //selectdata: [".", ","],
            changeFlag: false,
            options: [],
            permissionFlag: true,
        }
        this.getSelectData();
        this.testPermission();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        })
        this.getUserInfo();
    }

    async getUserInfo() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        //let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        //this.props.updateFetchTime();
        //const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        //const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: this.props.reduxData.userInfo,
            loading: false,
            username: this.props.reduxData.userInfo.username,
        });
        this.setState({
            globalLevel: this.props.reduxData.userInfo.level.pk
        });
        //var dept = this.props.reduxData.userInfo.level.pk
        //dept = dept.substring(0, (dept.indexOf('-') - 1));
        //this.recordComingHere();
        this.getSelectData();
        this.testPermission();
    }

    //async recordComingHere() {
    //    let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let toSend = {
    //        pagePK: "1023",
    //        department: this.props.reduxData.userInfo.level.pk,
    //        userPCID: this.props.reduxData.userInfo.pcid,
    //        ip: this.state.ip,
    //        browser: this.state.browser,
    //        userID: this.props.reduxData.userInfo.username
    //    }
    //    const response = await fetch('logging', {
    //        method: 'POST',
    //        headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
    //        body: JSON.stringify(toSend)
    //    });
    //    const data = await response.json();
    //    localStorage.setItem("lastFetch", moment());
        
    //}

    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1023"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    async getOptions(input) { //This fetch returns the classes from Campus6_40.sections that are in the SummerI and SummerII sessions for the year given.
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            year: input,
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('AcadeumOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            options: data
        })
    }

    async getSelectData() { //This fetch returns all distinct years in the Acadeum connections table. It won't just return the most recent one even though getOptions()
        //only returns the most recent summer session's classes, which means it would be possible to associate an old Acadeum class with a current Hood class.
        //Investigate disabling the options select when a non - current year is selected ?
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        const response = await fetch('AcadeumYear', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            selectdata: data.year
        });

    }

    componentDidMount() {
        
    }

    async getTableData(input) {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            year: input.target.value,
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        this.setState({
            selectVal: input.target.value
        })
        const response = await fetch('AcadeumClasses', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            tableData: data,
        }, () => {
            this.getOptions(input.target.value);
            this.setState({//This is a completely separate this.setState() function because I wanted to ensure this happens only after the table data has been successfully stored in state
                            //UPDATE 20230517: because this.setState() is asynchronous, on review this needs to be moved into a callback within the table data setState to make sure it executes after state update
                loadingTable: false
            })
        });
        
    }

    async refreshTable(input) {//The entire purpose of this function is to do the same thing as this.getTableData() but without having to rely on an event target
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            year: input,
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('AcadeumClasses', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            tableData: data,
        });
        this.setState({
            loadingTable: false
        })
    }

    async updateConnection(data1, data2, data3) {//data2 is the event.target.value while data1 and data3 are read values. This is very exciting.
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            pk: data1,
            newVal: data2,
            userLevel: data3
        }
        const response = await fetch('UpdateAcadeum', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            changeFlag: data
        });
        setTimeout(() => {
            this.setState({
                changeFlag: false
            })

        }, 5000)
        this.refreshTable(this.state.selectVal);//Because this is outside of the setTimeout() it executes before the Success flag goes away
    }

    renderTable(tableData, options) {/*This is something I've wanted to try and do ever since I remembered it was possible. This function is only going to be 
                                        displayed to render after the information it needs has been retrieved, and the function that calls those controllers 
                                        will end with switching a state flag to false to tell render() to display this function
                                        As it turns out, though, while we're in here we can't map() through this.state values like we could if we were in 
                                        render() proper. So, we have to take those state values and pass them into here as parameters.
                                        Also, in the example I was looking at while writing this from Microsoft's HelloWorld program, this sub-render function
                                        was a static function because it would get information and then populate it with nothing changing. For our purposes, though,
                                        we needed the select option in the last field of the table to actually be able to do things which means this can't be static.
                                        That works fine, but it also means in the render() logic we need to reference this as this.renderTable() instead of 
                                        Acadeum.renderTable() like we would've done had this been a static function*/
                                        //20230517: on review there's no way we can't actually .map() state values in here, I've done it in other components. Re-evaluate in test branch.
        return (
            <UserContext.Consumer>
                {contextData => (
                    <div>
                        <Table striped>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Institute</th>
                                    <th>Institute Course Code</th>
                                    <th>Institute Course Title</th>
                                    <th>Credits</th>
                                    <th>Session</th>
                                    <th>Section</th>
                                    <th>Current Hood Section ID</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.map(size => (
                                    <tr>
                                        <th>{size.pk}</th>
                                        <td>{size.institute}</td>
                                        <td>{size.courseCode}</td>
                                        <td>{size.courseTitle}</td>
                                        <td>{size.credits}</td>
                                        <td>{size.session}</td>
                                        <td>{size.section}</td>
                                        <td>{size.hoodSection}</td>
                                        <td><Form><Input type="select" name="newVal" id="newVal" onChange={(event) => this.updateConnection(size.pk, event.target.value, contextData[0])}>
                                            <option value="0">Select New</option>
                                            {options.map(size2 => (
                                                <option value={size2.sectionID} onChange={() => this.updateConnection(size.pk, size2.sectionID)}>{size2.event_id_info}</option>))}
                                        </Input></Form></td>
                                        {/*We're using contextData[0] for our global level value because we can't actually get state information while we're in here.
                                         I probably could've passed in this.state.globalLevel as a parameter, but getting this value from context is safer*/}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>)}
            </UserContext.Consumer>
        );
    }

    render() {
        let info;
        if (this.state.loadingTable) {
            info = <p><em>Waiting...</em></p>
        }
        else { info = this.renderTable(this.state.tableData, this.state.options) }
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        //if (this.props.justSwitch == true) {
        //    this.props.passNewPage(1);
        //}
            return (
                <UserContext.Consumer>
                    {contextData => (
                        <div>
                            <Form inline className="d-flex">
                                <FormGroup>
                                    <Label for="acadeumYear">Year</Label>
                                    <Input type="select" name="year" id="inputYear" onChange={this.getTableData.bind(this)}>
                                        <option>Select Year</option>
                                        {this.state.selectdata.map(size => (
                                            <option>{size}</option>))}
                                    </Input><div style={{ visibility: this.state.changeFlag == true ? 'visible' : 'hidden' }}> Success! <GoCheck style={{ visibility: this.state.changeFlag == true ? 'visible' : 'hidden' }} /></div>
                                </FormGroup>
                            </Form>
                            {info}
                        </div>
                    )}
                </UserContext.Consumer>
            );
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(Acadeum);